import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function SortAscIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.247736 2.51062L2.41193 0.254763C2.73782 -0.0849211 3.26424 -0.0849211 3.59013 0.254763L5.75432 2.51062C6.28075 3.05934 5.90473 4 5.16105 4H0.832654C0.088972 4 -0.278691 3.05934 0.247736 2.51062Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
